import { useEffect } from "react";
import { getUploadManager } from "~/lib/uploads";
import { useHasActiveTransfer } from "~/stores/uploadQueueStore";
import { UploadQueueWidget } from "./UploadQueueWidget";

// Mounted once at the Inertia layout, above the page layer. Initializes the
// upload manager singleton, registers the `beforeunload` guard ONLY while
// parts are in flight, and renders the persistent corner queue.
export function UploadManagerMount() {
  const hasActiveTransfer = useHasActiveTransfer();

  // Instantiate the singleton on first mount so Golden Retriever can restore
  // any interrupted queue immediately on load.
  useEffect(() => {
    getUploadManager();
  }, []);

  // The guard is registered only while a transfer is actually running — never
  // while a file is merely queued, paused, or after the bytes have landed.
  useEffect(() => {
    if (!hasActiveTransfer) return;
    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      // Legacy browsers require returnValue to be set to trigger the prompt.
      e.returnValue = "";
      return "";
    };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [hasActiveTransfer]);

  return <UploadQueueWidget />;
}
